/*
 * @Author: your name
 * @Date: 2020-04-03 11:23:51
 * @LastEditTime: 2021-03-19 10:11:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/sensors.js
 */
/**
 * 神策埋点上报
 */
// 按钮类型
const buttonType = (attr, eventName = 'coupon_list_click') => {
  window.sensors && window.sensors.track(eventName, {
    button_type: attr
  }, () => {
    console.log('callback');
  });
};
// 页面名称
const couponType = (attr, eventName = 'coupon_list_click') => {
  window.sensors && window.sensors.track(eventName, {
    coupon_type: attr
  }, () => {
    console.log('callback');
  });
};
// 页面曝光
const pageView = (attr, eventName = 'coupon_list_exposure') => {
  window.sensors && window.sensors.track(eventName, {
    page_view: attr
  }, () => {
    console.log('callback');
  });
};
// 模块名称
const moduleName = (attr, eventName = 'coupon_list_click') => {
  window.sensors && window.sensors.track(eventName, {
    module_name: attr
  }, () => {
    console.log('callback');
  });
};

/// 企业券 埋点
// 模块类型
const moduleType = (attr, eventName = 'coupon_list_click') => {
  window.sensors && window.sensors.track(eventName, {
    module_type: attr
  }, () => {
    console.log('callback');
  });
};
// 交互类型
const actType = (attr, eventName = 'coupon_list_click') => {
  window.sensors && window.sensors.track(eventName, {
    act_type: attr
  }, () => {
    console.log('callback');
  });
};
// 页面类型
const pageType = (attr, eventName = 'coupon_list_click') => {
  window.sensors && window.sensors.track(eventName, {
    page_type: attr
  }, () => {
    console.log('callback');
  });
};
// 页面名称
const pageName = (attr, eventName = 'coupon_list_click') => {
  window.sensors && window.sensors.track(eventName, {
    page_name: attr
  }, () => {
    console.log('callback');
  });
};
// 模块名称外部传入
const post = (obj, eventName = 'coupon_list_click') => {
  window.sensors && window.sensors.track(eventName, obj, () => {
    console.log('callback');
  });
};

// 优惠券列表页_点击
const COUPON_LIST_CLICK = 'coupon_list_click';
// 优惠券列表页_曝光
const COUPON_LIST_EXPOSURE = 'coupon_list_exposure';

export default {
  COUPON_LIST_CLICK,
  COUPON_LIST_EXPOSURE,
  buttonType,
  couponType,
  pageView,
  moduleName,
  pageName,
  pageType,
  actType,
  moduleType,
  post
};
